import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { SnackbarProvider } from 'notistack';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import Layout from './components/Layout';
import Orders from './pages/Orders';
import Producten from './pages/Producten';
import Login from './components/Login';
import Register from './components/Register';
import Profile from './pages/Profile';
import Dashboard from './pages/Dashboard';
import MoneybirdFacturen from './pages/MoneybirdFacturen';
import PrivateRoute from './components/PrivateRoute';
import { AuthProvider } from './contexts/AuthContext';
import { GoogleMapsProvider } from './contexts/GoogleMapsContext';
import AuthCallback from './components/AuthCallback';
import SetPassword from './components/SetPassword';
// Import Admin pages
import AdminLayout from './components/AdminLayout';
import AdminDashboard from './pages/admin/Dashboard';
import AdminProducts from './pages/admin/Products';
import AdminProductForm from './pages/admin/ProductForm';
import Companies from './pages/admin/Companies';
import CompanyProducts from './pages/admin/CompanyProducts';
import OrdersAdmin from './pages/admin/orders';
import LeveranciersAdmin from './pages/admin/leveranciers';
import AdminSettings from './pages/admin/Settings';
import AdminRoute from './components/AdminRoute';

// Create routes configuration
const routes = (
  <Routes>
    <Route path="/login" element={<Login />} />
    <Route path="/register" element={<Register />} />
    <Route path="/auth/callback" element={<AuthCallback />} />
    <Route path="/set-password" element={<SetPassword />} />
    <Route path="/" element={<Layout />}>
      <Route index element={<PrivateRoute><Dashboard /></PrivateRoute>} />
      <Route path="dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
      <Route path="producten" element={<PrivateRoute><Producten /></PrivateRoute>} />
      <Route path="orders" element={<PrivateRoute><Orders /></PrivateRoute>} />
      <Route path="facturen" element={<PrivateRoute><MoneybirdFacturen /></PrivateRoute>} />
      <Route path="profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
    </Route>
    
    {/* Admin routes */}
    <Route path="/admin" element={<AdminLayout />}>
      <Route index element={<AdminRoute><AdminDashboard /></AdminRoute>} />
      <Route path="products" element={<AdminRoute><AdminProducts /></AdminRoute>} />
      <Route path="products/new" element={<AdminRoute><AdminProductForm /></AdminRoute>} />
      <Route path="products/:id" element={<AdminRoute><AdminProductForm /></AdminRoute>} />
      <Route path="products/:id/view" element={<AdminRoute><AdminProductForm viewOnly={true} /></AdminRoute>} />
      
      {/* Companies routes (replacing organizations) */}
      <Route path="companies" element={<AdminRoute><Companies /></AdminRoute>} />
      <Route path="companies/:id" element={<AdminRoute><Companies viewSingle={true} /></AdminRoute>} />
      <Route path="companies/:id/products" element={<AdminRoute><CompanyProducts /></AdminRoute>} />
      <Route path="companies/:id/edit" element={<AdminRoute><Companies editMode={true} /></AdminRoute>} />
      <Route path="companies/new" element={<AdminRoute><Companies createMode={true} /></AdminRoute>} />
      
      {/* Keep old routes for backward compatibility but redirect to new ones */}
      <Route path="clients" element={<Navigate to="/admin/companies" />} />
      <Route path="clients/:id" element={<Navigate to="/admin/companies/:id" replace />} />
      <Route path="clients/:id/products" element={<Navigate to="/admin/companies/:id/products" replace />} />
      <Route path="organizations" element={<Navigate to="/admin/companies" />} />
      <Route path="organizations/:id" element={<Navigate to="/admin/companies/:id" replace />} />
      <Route path="organizations/:id/products" element={<Navigate to="/admin/companies/:id/products" replace />} />
      <Route path="organizations/:id/edit" element={<Navigate to="/admin/companies/:id/edit" replace />} />
      <Route path="organizations/new" element={<Navigate to="/admin/companies/new" replace />} />
      
      <Route path="orders" element={<AdminRoute><OrdersAdmin /></AdminRoute>} />
      <Route path="orders/:id" element={<AdminRoute><OrdersAdmin viewSingle={true} /></AdminRoute>} />
      <Route path="leveranciers" element={<AdminRoute><LeveranciersAdmin /></AdminRoute>} />
      <Route path="settings" element={<AdminRoute><AdminSettings /></AdminRoute>} />
    </Route>
  </Routes>
);

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SnackbarProvider maxSnack={3}>
        <AuthProvider>
          <GoogleMapsProvider>
            <Router>
              {routes}
            </Router>
          </GoogleMapsProvider>
        </AuthProvider>
      </SnackbarProvider>
    </ThemeProvider>
  );
}
